import { useState } from 'react';

import styled from 'styled-components';

import { Spinner } from '@components/loading-spinner';
import { Stack } from '@components/stack';

import { BaseTab } from './common';
import { Header, HeaderProps } from './header';
import { StateTabs } from './state-tabs';

export type TabProps = BaseTab & {
  id: string;
};

export type TabsHeaderProps = Omit<HeaderProps, 'tabs'> & {
  tabs: TabProps[];
  defaultActiveTab?: string;
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
  isLoading?: boolean;
};

export const TabsHeader = ({
  tabs,
  defaultActiveTab,
  activeTab: controlledActiveTab,
  onTabChange,
  isLoading,
  ...rest
}: TabsHeaderProps) => {
  const [internalActiveTab, setInternalActiveTab] = useState(defaultActiveTab || tabs[0]?.id);
  const activeTab = controlledActiveTab ?? internalActiveTab;

  const handleTabChange = (tabId: string) => {
    if (controlledActiveTab === undefined) {
      setInternalActiveTab(tabId);
    }
    onTabChange?.(tabId);
  };

  const activeTabContent = tabs.find((tab) => tab.id === activeTab)?.content;

  return (
    <Container>
      <Header
        tabs={<StateTabs tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />}
        {...rest}
      />
      <ContentWrapper>{isLoading ? <Spinner /> : activeTabContent}</ContentWrapper>
    </Container>
  );
};

const Container = styled(Stack)({
  height: '100%',
  minHeight: 0,
});

const ContentWrapper = styled(Stack)({
  flex: '1 1 auto',
  minHeight: 0,
  overflow: 'hidden',
});
